/* CBC — correctifs et interactions de la colonne de gauche des PDP.

   1. srcset : l'image principale des buy box est rendue avec `srcset` + `sizes`. Le navigateur
      choisit alors sa source dans le srcset et IGNORE `src` : les scripts de section qui font
      `main.src = ...` modifient le DOM sans rien changer à l'écran. On retire srcset/sizes.

   2. Préchargement : sans lui, chaque clic sur une vignette déclenche le téléchargement d'une
      image 1200 px, d'où une attente d'une demi-seconde à chaque changement. On met les
      grandes versions en cache navigateur une fois la page chargée, en tâche de fond.

   3. Flèches image : un bouton précédent / suivant par-dessus l'image principale. Ils simulent
      un clic sur la vignette voisine, donc héritent du comportement de chaque section.

   4. Scroll vignettes : la colonne est bornée à la hauteur de l'image (CSS) ; deux flèches
      haut/bas atteignent celles qui dépassent.

   5. Badge d'accroche : il n'a de sens que sur la première image, celle qui a été composée
      pour l'accueillir. On le masque dès qu'une autre vignette est active.

   6. Carrousel d'avis : chevrons, défilement auto et balayage. */
(function () {
  "use strict";

  var PATH_LEFT = "M15 6l-6 6l6 6";
  var PATH_RIGHT = "M9 6l6 6l-6 6";
  var PATH_UP = "M6 15l6 -6l6 6";
  var PATH_DOWN = "M6 9l6 6l6 -6";
  var REVIEW_DELAY = 5000;

  function scopeOf(root) {
    return root && root.querySelectorAll ? root : document;
  }

  function stripSrcset(root) {
    var imgs = scopeOf(root).querySelectorAll("img[data-main]");
    for (var i = 0; i < imgs.length; i++) {
      var img = imgs[i];
      if (!img.hasAttribute("srcset") && !img.hasAttribute("sizes")) continue;
      img.removeAttribute("srcset");
      img.removeAttribute("sizes");
    }
  }

  function thumbsOf(gal) {
    return Array.prototype.slice.call(gal.querySelectorAll("[data-thumb]"));
  }

  function largeSrc(thumbSrc) {
    return thumbSrc.replace(/width=\d+/, "width=1200");
  }

  /* Mise en cache des grandes versions, une fois la page chargée et le fil d'exécution libre.
     Sans ça, le premier clic sur chaque vignette attend un aller-retour réseau complet. */
  function preload(gal) {
    if (gal.getAttribute("data-cbc-pre")) return;
    gal.setAttribute("data-cbc-pre", "1");
    var list = thumbsOf(gal);
    var i = 0;
    function next() {
      if (i >= list.length) return;
      var img = new Image();
      img.decoding = "async";
      img.src = largeSrc(list[i].src);
      i++;
      /* Une image à la fois : un lot de vingt requêtes simultanées entrerait en concurrence
         avec le reste de la page. */
      if (img.decode) { img.decode().then(next, next); } else { img.onload = next; img.onerror = next; }
    }
    next();
  }

  function schedulePreload(gal) {
    var run = function () { preload(gal); };
    if (window.requestIdleCallback) window.requestIdleCallback(run, { timeout: 3000 });
    else window.setTimeout(run, 1200);
  }

  /* Le badge ne reste visible que sur la première vignette. */
  function syncKicker(gal) {
    var kicker = gal.querySelector(".gal-main .kicker");
    if (!kicker) return;
    var list = thumbsOf(gal);
    if (list.length < 2) return;
    var activeIndex = 0;
    for (var i = 0; i < list.length; i++) {
      if (list[i].hasAttribute("data-active")) { activeIndex = i; break; }
    }
    kicker.style.display = activeIndex === 0 ? "" : "none";
  }

  function makeButton(cls, flag, path, size, label) {
    var b = document.createElement("button");
    b.type = "button";
    b.className = cls;
    if (flag) b.setAttribute(flag, "");
    b.setAttribute("aria-label", label);
    b.innerHTML =
      '<svg viewBox="0 0 24 24" width="' + size + '" height="' + size + '" fill="none"' +
      ' stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"' +
      ' aria-hidden="true"><path d="' + path + '"/></svg>';
    return b;
  }

  function addImageNav(gal) {
    if (gal.getAttribute("data-cbc-nav")) return;
    var main = gal.querySelector(".gal-main");
    if (!main || thumbsOf(gal).length < 2) return;
    gal.setAttribute("data-cbc-nav", "1");

    function step(delta) {
      var list = thumbsOf(gal);
      if (list.length < 2) return;
      var i = 0;
      for (var k = 0; k < list.length; k++) {
        if (list[k].hasAttribute("data-active")) i = k;
      }
      var n = (i + delta + list.length) % list.length;
      list[n].click();
      if (list[n].scrollIntoView) {
        list[n].scrollIntoView({ block: "nearest", inline: "nearest" });
      }
      syncKicker(gal);
    }

    var prev = makeButton("gal-nav", "data-prev", PATH_LEFT, 15, "Image pr\u00e9c\u00e9dente");
    var next = makeButton("gal-nav", "data-next", PATH_RIGHT, 15, "Image suivante");
    prev.addEventListener("click", function (e) { e.preventDefault(); step(-1); });
    next.addEventListener("click", function (e) { e.preventDefault(); step(1); });
    main.appendChild(prev);
    main.appendChild(next);

    /* Le gestionnaire de la section met à jour data-active sur le même clic : on relit
       l'état juste après, une fois la pile d'événements vidée. */
    gal.addEventListener("click", function (e) {
      if (!e.target || !e.target.closest) return;
      if (!e.target.closest("[data-thumb], .thumb")) return;
      window.setTimeout(function () { syncKicker(gal); }, 0);
    });

    syncKicker(gal);
  }

  function addThumbScroller(gal) {
    if (gal.getAttribute("data-cbc-thumbnav")) return;
    var strip = gal.querySelector(".gal-thumbs");
    if (!strip || thumbsOf(gal).length < 2) return;
    gal.setAttribute("data-cbc-thumbnav", "1");

    var up = makeButton("gal-thumbnav", "data-thumbs-up", PATH_UP, 14, "Vignettes pr\u00e9c\u00e9dentes");
    var down = makeButton("gal-thumbnav", "data-thumbs-down", PATH_DOWN, 14, "Vignettes suivantes");

    function sync() {
      var max = strip.scrollHeight - strip.clientHeight;
      var scrollable = max > 2;
      up.hidden = !scrollable || strip.scrollTop <= 2;
      down.hidden = !scrollable || strip.scrollTop >= max - 2;
    }

    function page(dir) {
      var amount = Math.max(86, Math.round(strip.clientHeight * 0.8));
      if (strip.scrollBy) strip.scrollBy({ top: dir * amount, behavior: "smooth" });
      else strip.scrollTop += dir * amount;
    }

    up.addEventListener("click", function (e) { e.preventDefault(); page(-1); });
    down.addEventListener("click", function (e) { e.preventDefault(); page(1); });
    strip.addEventListener("scroll", sync);
    window.addEventListener("resize", sync);

    gal.appendChild(up);
    gal.appendChild(down);
    sync();

    window.setTimeout(sync, 400);
    window.addEventListener("load", sync);
  }

  function addReviewCarousel(host) {
    if (host.getAttribute("data-cbc-rev")) return;
    var track = host.querySelector(".hr-track");
    if (!track) return;
    var slides = track.querySelectorAll(".hr-slide");
    if (slides.length < 2) return;
    host.setAttribute("data-cbc-rev", "1");

    var idx = 0;
    var paused = false;

    function goTo(n) {
      idx = (n + slides.length) % slides.length;
      if (track.scrollTo) track.scrollTo({ left: idx * track.clientWidth, behavior: "smooth" });
      else track.scrollLeft = idx * track.clientWidth;
    }

    track.addEventListener("scroll", function () {
      if (!track.clientWidth) return;
      idx = Math.round(track.scrollLeft / track.clientWidth);
    });

    var prev = makeButton("hr-prev", null, PATH_LEFT, 14, "Avis pr\u00e9c\u00e9dent");
    var next = makeButton("hr-next", null, PATH_RIGHT, 14, "Avis suivant");
    prev.addEventListener("click", function (e) { e.preventDefault(); goTo(idx - 1); });
    next.addEventListener("click", function (e) { e.preventDefault(); goTo(idx + 1); });
    host.appendChild(prev);
    host.appendChild(next);

    host.addEventListener("pointerenter", function () { paused = true; });
    host.addEventListener("pointerleave", function () { paused = false; });
    host.addEventListener("touchstart", function () { paused = true; }, { passive: true });
    host.addEventListener("touchend", function () {
      window.setTimeout(function () { paused = false; }, 6000);
    }, { passive: true });

    var reduced = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (!reduced) {
      window.setInterval(function () { if (!paused) goTo(idx + 1); }, REVIEW_DELAY);
    }
  }

  function init(root) {
    stripSrcset(root);
    var scope = scopeOf(root);
    var gals = scope.querySelectorAll(".gal");
    for (var i = 0; i < gals.length; i++) {
      addImageNav(gals[i]);
      addThumbScroller(gals[i]);
      syncKicker(gals[i]);
      schedulePreload(gals[i]);
    }
    var revs = scope.querySelectorAll("[data-review-carousel]");
    for (var j = 0; j < revs.length; j++) addReviewCarousel(revs[j]);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () { init(); });
  } else {
    init();
  }

  document.addEventListener("shopify:section:load", function (e) { init(e.target); });
})();
